import { api } from './client';

/** Singleton `shop_config` row as drizzle serialises it. */
export type ShopConfig = {
  id: string;
  shopOpen: boolean;
  closureMessage: string;
  estimatedShipDate: string;
  paczkomatCostAGrosze: number;
  paczkomatCostBGrosze: number;
  paczkomatCostCGrosze: number;
  kurierCostAGrosze: number;
  kurierCostBGrosze: number;
  kurierCostCGrosze: number;
  ticketShirtQuotaPerColor: number;
  boothAddress: string;
  courierDropoffPoint: string;
  concertDate: string;
  updatedAt: string;
};

/** The write endpoint takes snake_case and applies only the keys present. */
export type ShopConfigPatch = Partial<{
  shop_open: boolean;
  closure_message: string;
  estimated_ship_date: string;
  paczkomat_cost_a_grosze: number;
  paczkomat_cost_b_grosze: number;
  paczkomat_cost_c_grosze: number;
  kurier_cost_a_grosze: number;
  kurier_cost_b_grosze: number;
  kurier_cost_c_grosze: number;
  ticket_shirt_quota_per_color: number;
  booth_address: string;
  courier_dropoff_point: string;
  concert_date: string;
  reason: string;
}>;

export class ShopConfigMissingError extends Error {
  constructor() {
    super('shop_config_missing');
  }
}

export async function getShopConfig(): Promise<ShopConfig> {
  const res = await api.get<{ config: ShopConfig | null }>('/admin/shop-config');
  // The row is seeded on API boot; a null here means the seed never ran, and editing fields of a
  // row that does not exist would report success while the UPDATE matches nothing.
  if (!res.config) throw new ShopConfigMissingError();
  return res.config;
}

export const updateShopConfig = (patch: ShopConfigPatch) =>
  api.post<{ ok: true }>('/admin/shop-config', patch);
